/*
 * $Id:: servicesItems.js 2020/11/10 02:48 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

export default {
    trademark: {
        services: [
            {
                title: 'trademark.e.filling',
                description: 'trademark.e.filling.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'trademark/e-filling',
            },
            {
                title: 'trademark.e.service',
                description: 'trademark.e.service.description',
                externalPath: false,
                requiredProfileDetails: false,
                path: 'trademark/e-services',
            },
            {
                title: 'search.trademark',
                description: 'search.trademark.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'trademark/search',
            },
            {
                title: 'all.trademark.entry.points',
                description: 'all.trademark.entry.points.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'trademark/all',
            },
            {
                title: 'favorites.tab.title.text',
                description: 'favorites.tab.title.description.trademark',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'trademark/favourites',
            },
        ],
        eFillings: [
            {
                title: 'request.national.trademark',
                category: 'other',
                description: 'request.national.trademark.description',
                externalPath: true,
                requiredProfileDetails: true,
                path: 'eservice.path.0599',
            },
            {
                title: 'request.international.trademark',
                category: 'other',
                description: 'request.international.trademark.description',
                externalPath: true,
                requiredProfileDetails: true,
                path: 'eservice.path.0592',
            },
            {
                title: 'request.logotype',
                category: 'other',
                description: 'request.logotype.description',
                externalPath: true,
                requiredProfileDetails: true,
                path: 'eservice.path.2099',
            },
            {
                title: 'request.association.trademark',
                category: 'other',
                description: 'request.association.trademark.description',
                externalPath: true,
                requiredProfileDetails: true,
                path: 'eservice.path.1599',
            },
            {
                title: 'request.certification.trademark',
                category: 'other',
                description: 'request.certification.trademark.description',
                externalPath: true,
                requiredProfileDetails: true,
                path: 'eservice.path.1699',
            },
            {
                title: 'request.national.appelation.origin',
                category: 'other',
                description: 'request.national.appelation.origin.description',
                externalPath: true,
                requiredProfileDetails: true,
                path: 'eservice.path.1299',
            },
            {
                title: 'request.trade.award',
                category: 'other',
                description: 'request.trade.award.description',
                externalPath: true,
                requiredProfileDetails: true,
                path: 'eservice.path.1199',
            },
        ],
        eServices: [
            {
                title: 'changes.in.application.registration',
                category: 'other',
                description: 'changes.in.application.registration.description',
                externalPath: false,
                requiredProfileDetails: false,
                path: 'e-services/changes-registration',
            },
            {
                title: 'recordals',
                category: 'other',
                description: 'recordals.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/recordals',
            },
            {
                title: 'observations',
                category: 'other',
                description: 'observations.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/observations',
            },
            {
                title: 'extinction.of.rights',
                category: 'other',
                description: 'extinction.of.rights.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/extinction-of-rights',
            },
            {
                title: 'modification.of.decision',
                category: 'other',
                description: 'modification.of.decision.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/modification-of-decision',
            },
            {
                title: 'opposition',
                category: 'other',
                description: 'opposition.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/opposition',
            },
            {
                title: 'proof.of.rights',
                category: 'other',
                description: 'proof.of.rights.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/proof-of-rights',
            },
            {
                title: 'reply.provisional.refusal',
                category: 'other',
                description: 'reply.provisional.refusal.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/reply-provisional-refusal',
            },
            {
                title: 'reestablishment.of.rights',
                category: 'other',
                description: 'reestablishment.of.rights.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/reestablishment-of-rights',
            },
            {
                title: 'suspension.and.time.changes',
                category: 'other',
                description: 'suspension.and.time.changes.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/suspension-time-changes',
            },
            {
                title: 'fees.renewal.revalidation',
                category: 'other',
                description: 'fees.renewal.revalidation.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/fees-renewal-revalidation',
            },
            {
                title: 'proof.of.use',
                category: 'other',
                description: 'proof.of.use.description',
                externalPath: true,
                requiredProfileDetails: true,
                path: 'eservice.path.0534',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: true,
                path: 'eservice.path.0530',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: true,
                path: 'eservice.path.0565',
            },
            {
                title: 'reply.to.notifications',
                category: 'other',
                description: 'reply.to.notifications.description',
                externalPath: true,
                requiredProfileDetails: true,
                path: 'tm.reply.to.notifications.path',
            },
            {
                title: 'registration.fee',
                category: 'other',
                description: 'registration.fee.description',
                externalPath: true,
                requiredProfileDetails: true,
                path: 'eservice.path.0590',
            },
            // {
            //     title: 'withdrawal',
            //     category: 'other',
            //     description: 'withdrawal.description',
            //     externalPath: true,
            //     requiredProfileDetails: true,
            //     path: 'eservice.path.0541',
            // },
        ],
        search: [
            {
                title: 'search.trademark',
                category: 'other',
                description: 'search.trademark.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'search.trademark.path',
            },
            {
                title: 'search.trademark.image',
                category: 'other',
                description: 'search.trademark.image.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'search.trademark.image',
            },
        ],
        changes: [
            {
                title: 'modification.of.non.essential.elements',
                category: 'other',
                description: 'modification.of.non.essential.elements.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0564',
            },
            {
                title: 'change.of.name.address',
                category: 'other',
                description: 'change.of.name.address.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0575',
            },
            {
                title: 'change.of.agent.representative',
                category: 'other',
                description: 'change.of.agent.representative.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0529',
            },
            {
                title: 'change.of.trade.sign',
                category: 'other',
                description: 'change.of.trade.sign.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0563',
            },
            {
                title: 'request.for.division',
                category: 'other',
                description: 'request.for.division.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0572',
            },
            {
                title: 'limitation.goods.services',
                category: 'other',
                description: 'limitation.goods.services.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0501',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0565',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0530',
            },
        ],
        recordals: [
            {
                title: 'assignment',
                category: 'other',
                description: 'assignment.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0582',
            },
            {
                title: 'other.recordals',
                category: 'other',
                description: 'other.recordals.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0579',
            },
            {
                title: 'license',
                category: 'other',
                description: 'license.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0577',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0565',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0530',
            },
        ],
        observations: [
            {
                title: 'observations',
                category: 'other',
                description: 'observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0551',
            },
            {
                title: 'reply.to.observations',
                category: 'other',
                description: 'reply.to.observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0550',
            },
        ],
        extinctionRights: [
            {
                title: 'renunciation',
                category: 'other',
                description: 'renunciation.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0540',
            },
            {
                title: 'request.for.lapse',
                category: 'other',
                description: 'request.for.lapse.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0537',
            },
            {
                title: 'reply.request.for.lapse',
                category: 'other',
                description: 'reply.request.for.lapse.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0538',
            },
            {
                title: 'request.for.invalidity',
                category: 'other',
                description: 'request.for.invalidity.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0542',
            },
            {
                title: 'reply.request.for.invalidity',
                category: 'other',
                description: 'reply.request.for.invalidity.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0502',
            },
            {
                title: 'reply.to.notification',
                category: 'other',
                description: 'reply.to.notification.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0531',
            },
            {
                title: 'observations',
                category: 'other',
                description: 'observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0551',
            },
            {
                title: 'reply.observations',
                category: 'other',
                description: 'reply.observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0550',
            },
            {
                title: 'proof.of.use',
                category: 'other',
                description: 'proof.of.use.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0534',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0565',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0530',
            },
        ],
        modificationDecision: [
            {
                title: 'request.modification.decision',
                category: 'other',
                description: 'request.modification.decision.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0536',
            },
            {
                title: 'reply.request.modification.decision',
                category: 'other',
                description: 'reply.request.modification.decision.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0525',
            },
            {
                title: 'proof.of.use',
                category: 'other',
                description: 'proof.of.use.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0534',
            },
            {
                title: 'observations',
                category: 'other',
                description: 'observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0551',
            },
            {
                title: 'reply.observations',
                category: 'other',
                description: 'reply.observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0550',
            },
            {
                title: 'suspension.examination',
                category: 'other',
                description: 'suspension.examination.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0547',
            },
            {
                title: 'extension.time.limits',
                category: 'other',
                description: 'extension.time.limits.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0549',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0565',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0530',
            },
        ],
        opposition: [
            {
                title: 'opposition',
                category: 'other',
                description: 'opposition.description.extra',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0555',
            },
            {
                title: 'reply.opposition',
                category: 'other',
                description: 'reply.opposition.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0554',
            },
            {
                title: 'proof.of.use',
                category: 'other',
                description: 'proof.of.use.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0534',
            },
            {
                title: 'observations.third.party',
                category: 'other',
                description: 'observations.third.party.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0557',
            },
            {
                title: 'observations',
                category: 'other',
                description: 'observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0551',
            },
            {
                title: 'reply.observations',
                category: 'other',
                description: 'reply.observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0550',
            },
            {
                title: 'suspension.examination',
                category: 'other',
                description: 'suspension.examination.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0547',
            },
            {
                title: 'extension.time.limits',
                category: 'other',
                description: 'extension.time.limits.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0549',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0565',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0530',
            },
        ],
        proofOfRights: [
            {
                title: 'request.proof.of.rights',
                category: 'other',
                description: 'request.proof.of.rights.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0566',
            },
            {
                title: 'extract.certificate',
                category: 'other',
                description: 'extract.certificate.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0574',
            },
        ],
        replyProvisionalRefusal: [
            {
                title: 'reply.provisional.refusal',
                category: 'other',
                description: 'reply.provisional.refusal.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0539',
            },
            {
                title: 'reply.provisional.refusal.with.request',
                category: 'other',
                description: 'reply.provisional.refusal.with.request.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0643',
            },
            {
                title: 'declaration.of.consent',
                category: 'other',
                description: 'declaration.of.consent.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0532',
            },
            {
                title: 'limitation.goods',
                category: 'other',
                description: 'limitation.goods.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0501',
            },
            {
                title: 'suspension.examination',
                category: 'other',
                description: 'suspension.examination.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0547',
            },
            {
                title: 'extension.time.limits',
                category: 'other',
                description: 'extension.time.limits.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0549',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0565',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0530',
            },
        ],
        reestablishmentRights: [
            {
                title: 'request.reestablishment.of.rights',
                category: 'other',
                description: 'request.reestablishment.of.rights.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0535',
            },
            {
                title: 'opposition.against.reestablishment.of.rights',
                category: 'other',
                description: 'opposition.against.reestablishment.of.rights.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0556',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0565',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0530',
            },
        ],
        suspensionTimeChanges: [
            {
                title: 'suspension.examination',
                category: 'other',
                description: 'suspension.examination.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0547',
            },
            {
                title: 'extension.time.limits',
                category: 'other',
                description: 'extension.time.limits.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0549',
            },
        ],
        feesRenewal: [
            {
                title: 'renewal.registration',
                category: 'other',
                description: 'renewal.registration.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0587',
            },
            {
                title: 'registration.fee',
                category: 'other',
                description: 'registration.fee.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0590',
            },
            {
                title: 'revalidation',
                category: 'other',
                description: 'revalidation.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0585',
            },
            {
                title: 'opposition.against.revalidation',
                category: 'other',
                description: 'opposition.against.revalidation.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0556',
            },
            {
                title: 'free.supplement',
                category: 'other',
                description: 'free.supplement.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0510',
            },
            {
                title: 'refund.fees',
                category: 'other',
                description: 'refund.fees.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0505',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0530',
            },
        ],
        categories: ['extend', 'protect', 'cancel', 'change', 'transfer', 'other'],
    },
    design: {
        services: [
            {
                title: 'design.e.filling',
                description: 'design.e.filling.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5499',
            },
            {
                title: 'design.e.service',
                description: 'design.e.service.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'design/e-services',
            },
            {
                title: 'design.search',
                description: 'design.search.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'design/search',
            },
            {
                title: 'all.design.entry.points',
                description: 'all.design.entry.points.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'design/all',
            },
            {
                title: 'favorites.tab.title.text',
                description: 'favorites.tab.title.description.design',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'design/favourites',
            },
        ],
        eServices: [
            {
                title: 'changes.in.application.registration',
                category: 'other',
                description: 'changes.in.application.registration.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/changes-registration',
            },
            {
                title: 'recordals',
                category: 'other',
                description: 'recordals.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/recordals',
            },
            {
                title: 'observations',
                category: 'other',
                description: 'observations.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/observations',
            },
            {
                title: 'extinction.of.rights',
                category: 'other',
                description: 'extinction.of.rights.description.design',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/extinction-of-rights',
            },
            {
                title: 'modification.of.decision',
                category: 'other',
                description: 'modification.of.decision.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/modification-of-decision',
            },
            {
                title: 'opposition',
                category: 'other',
                description: 'opposition.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/opposition',
            },
            {
                title: 'proof.of.rights',
                category: 'other',
                description: 'proof.of.rights.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/proof-of-rights',
            },
            {
                title: 'reestablishment.of.rights',
                category: 'other',
                description: 'reestablishment.of.rights.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/reestablishment-of-rights',
            },
            {
                title: 'suspension.and.time.changes',
                category: 'other',
                description: 'suspension.and.time.changes.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/suspension-time-changes',
            },
            {
                title: 'fees.renewal.revalidation',
                category: 'other',
                description: 'fees.renewal.revalidation.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/fees-renewal-revalidation',
            },
            {
                title: 'reply.to.notifications',
                category: 'other',
                description: 'reply.to.notifications.description',
                externalPath: true,
                requiredProfileDetails: true,
                path: 'ds.reply.to.notifications.path',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: true,
                path: 'eservice.path.5430',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: true,
                path: 'eservice.path.5465',
            },
            {
                title: 'withdrawal',
                category: 'other',
                description: 'withdrawal.ds.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5441',
            },
        ],
        search: [
            {
                title: 'search.design',
                category: 'other',
                description: 'search.design.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'search.design.path',
            },
            {
                title: 'search.design.image',
                category: 'other',
                description: 'search.design.image.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0004',
            },
        ],
        changes: [
            {
                title: 'modification.of.non.essential.elements',
                category: 'other',
                description: 'modification.of.non.essential.elements.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5464',
            },
            {
                title: 'change.of.name.address',
                category: 'other',
                description: 'change.of.name.address.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5475',
            },
            {
                title: 'change.of.agent.representative',
                category: 'other',
                description: 'change.of.agent.representative.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5429',
            },
            {
                title: 'request.correction.elements',
                category: 'other',
                description: 'request.correction.elements.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5463',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5465',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5430',
            },
        ],
        recordals: [
            {
                title: 'assignment',
                category: 'other',
                description: 'assignment.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5482',
            },
            {
                title: 'other.recordals',
                category: 'other',
                description: 'other.recordals.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5479',
            },
            {
                title: 'license',
                category: 'other',
                description: 'license.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5477',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5465',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5430',
            },
        ],
        observations: [
            {
                title: 'observations',
                category: 'other',
                description: 'observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5451',
            },
            {
                title: 'reply.to.observations',
                category: 'other',
                description: 'reply.to.observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5450',
            },
        ],
        extinctionRights: [
            {
                title: 'renunciation',
                category: 'other',
                description: 'renunciation.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5440',
            },
            {
                title: 'request.for.invalidity',
                category: 'other',
                description: 'request.for.invalidity.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5442',
            },
            {
                title: 'reply.request.for.invalidity',
                category: 'other',
                description: 'reply.request.for.invalidity.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5402',
            },
            {
                title: 'reply.to.notification',
                category: 'other',
                description: 'reply.to.notification.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5402',
            },
            {
                title: 'observations',
                category: 'other',
                description: 'observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5451',
            },
            {
                title: 'reply.observations',
                category: 'other',
                description: 'reply.observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5450',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5465',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5430',
            },
        ],
        modificationDecision: [
            {
                title: 'request.modification.decision',
                category: 'other',
                description: 'request.modification.decision.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5436',
            },
            {
                title: 'reply.request.modification.decision',
                category: 'other',
                description: 'reply.request.modification.decision.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5425',
            },
            {
                title: 'observations',
                category: 'other',
                description: 'observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5451',
            },
            {
                title: 'reply.observations',
                category: 'other',
                description: 'reply.observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5450',
            },
            {
                title: 'suspension.examination',
                category: 'other',
                description: 'suspension.examination.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5447',
            },
            {
                title: 'extension.time.limits',
                category: 'other',
                description: 'extension.time.limits.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5449',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5465',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5430',
            },
        ],
        opposition: [
            {
                title: 'opposition',
                category: 'other',
                description: 'opposition.description.extra',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5455',
            },
            {
                title: 'reply.opposition',
                category: 'other',
                description: 'reply.opposition.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5454',
            },
            {
                title: 'observations',
                category: 'other',
                description: 'observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5451',
            },
            {
                title: 'reply.observations',
                category: 'other',
                description: 'reply.observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5450',
            },
            {
                title: 'suspension.examination',
                category: 'other',
                description: 'suspension.examination.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5447',
            },
            {
                title: 'extension.time.limits',
                category: 'other',
                description: 'extension.time.limits.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5449',
            },
            // {
            //     title: 'withdrawal',
            //     category: 'other',
            //     description: 'withdrawal.description',
            //     externalPath: true,
            //     requiredProfileDetails: false,
            //     path: 'eservice.path.5441',
            // },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5465',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5430',
            },
        ],
        proofOfRights: [
            {
                title: 'request.proof.of.rights',
                category: 'other',
                description: 'request.proof.of.rights.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5466',
            },
            {
                title: 'extract.certificate',
                category: 'other',
                description: 'extract.certificate.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5474',
            },
        ],
        reestablishmentRights: [
            {
                title: 'request.reestablishment.of.rights',
                category: 'other',
                description: 'request.reestablishment.of.rights.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5435',
            },
            {
                title: 'opposition.against.reestablishment.of.rights',
                category: 'other',
                description: 'opposition.against.reestablishment.of.rights.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5456',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5465',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5430',
            },
        ],
        suspensionTimeChanges: [
            {
                title: 'suspension.examination',
                category: 'other',
                description: 'suspension.examination.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5447',
            },
            {
                title: 'extension.time.limits',
                category: 'other',
                description: 'extension.time.limits.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5449',
            },
            {
                title: 'deferment.of.publication',
                category: 'other',
                description: 'deferment.of.publication.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5461',
            },
        ],
        feesRenewal: [
            {
                title: 'renewal.registration',
                category: 'other',
                description: 'design.renewal.registration.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5487',
            },
            {
                title: 'revalidation',
                category: 'other',
                description: 'revalidation.description.ds',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5485',
            },
            {
                title: 'opposition.against.revalidation',
                category: 'other',
                description: 'opposition.against.revalidation.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5459',
            },
            {
                title: 'free.supplement',
                category: 'other',
                description: 'free.supplement.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5410',
            },
            {
                title: 'refund.fees',
                category: 'other',
                description: 'refund.fees.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5405',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.5430',
            },
        ],
        categories: ['extend', 'cancel', 'change', 'transfer', 'other'],
    },
    patents: {
        services: [
            {
                title: 'patent.e.filling',
                description: 'patent.e.filling.description',
                externalPath: false,
                requiredProfileDetails: false,
                path: 'patents/e-filling',
            },
            {
                title: 'patent.e.service',
                description: 'patent.e.service.description',
                externalPath: false,
                requiredProfileDetails: false,
                path: 'patents/e-services',
            },
            {
                title: 'search.patent',
                description: 'search.patent.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'https://servicosonline.inpi.pt/pesquisas/main/patentes.jsp',
            },
            {
                title: 'all.patent.entry.points',
                description: 'all.patent.entry.points.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'patents/all',
            },
            {
                title: 'favorites.tab.title.text',
                description: 'favorites.tab.title.description.patents',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'patents/favourites',
            },
        ],
        eFillings: [
            {
                title: 'request.national.patent',
                category: 'other',
                description: 'request.national.patent.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0199',
            },
            {
                title: 'request.provisional.patent.application',
                category: 'other',
                description: 'request.provisional.patent.application.description',
                externalPath: false,
                requiredProfileDetails: false,
                path: 'e-filling/request-provisional-patent',
            },
            {
                title: 'request.national.utility.model',
                category: 'other',
                description: 'request.national.utility.model.description',
                externalPath: false,
                requiredProfileDetails: false,
                path: 'e-filling/request-national-utility-model',
            },
            {
                title: 'request.supplementary.protection.certificate',
                category: 'other',
                description: 'request.supplementary.protection.certificate.description',
                externalPath: false,
                requiredProfileDetails: false,
                path: 'e-filling/request-supplementary-protection',
            },
            {
                title: 'request.semiconductor.topography',
                category: 'other',
                description: 'request.semiconductor.topography.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.3099',
            },
            {
                title: 'request.european.patent',
                category: 'other',
                description: 'request.european.patent.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-filling/request-european-patent',
            },
            {
                title: 'request.international.patent',
                category: 'other',
                description: 'request.international.patent.description',
                externalPath: false,
                requiredProfileDetails: false,
                path: 'e-filling/request-international-patent',
            },
        ],
        eServices: [
            {
                title: 'changes.in.application.registration',
                category: 'other',
                description: 'changes.in.application.registration.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/changes-registration',
            },
            {
                title: 'recordals',
                category: 'other',
                description: 'recordals.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/recordals',
            },
            {
                title: 'observations',
                category: 'other',
                description: 'observations.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/observations',
            },
            {
                title: 'extinction.of.rights',
                category: 'other',
                description: 'extinction.of.rights.description.patents',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/extinction-of-rights',
            },
            {
                title: 'modification.of.decision',
                category: 'other',
                description: 'modification.of.decision.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/modification-of-decision',
            },
            {
                title: 'opposition',
                category: 'other',
                description: 'opposition.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/opposition',
            },
            // {
            //     title: 'reply.to.notifications',
            //     category: 'other',
            //     description: 'reply.to.notifications.description',
            //     externalPath: false,
            //     requiredProfileDetails: true,
            //     path: 'e-services/reply-notifications',
            // },
            {
                title: 'proof.of.rights',
                category: 'other',
                description: 'proof.of.rights.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/proof-of-rights',
            },
            {
                title: 'reestablishment.of.rights',
                category: 'other',
                description: 'reestablishment.of.rights.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/reestablishment-of-rights',
            },
            {
                title: 'suspension.and.time.changes',
                category: 'other',
                description: 'suspension.and.time.changes.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/suspension-time-changes',
            },
            {
                title: 'fees.renewal.revalidation',
                category: 'other',
                description: 'fees.renewal.revalidation.description',
                externalPath: false,
                requiredProfileDetails: true,
                path: 'e-services/fees-renewal-revalidation',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: true,
                path: 'eservice.path.0130',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: true,
                path: 'eservice.path.0165',
            },
            {
                title: 'withdrawal',
                category: 'other',
                description: 'withdrawal.description.pt',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0141',
            }
        ],
        changes: [
            {
                title: 'modification.of.non.essential.elements',
                category: 'other',
                description: 'modification.of.non.essential.elements.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0164',
            },
            {
                title: 'change.of.name.address',
                category: 'other',
                description: 'change.of.name.address.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0175',
            },
            {
                title: 'change.of.agent.representative',
                category: 'other',
                description: 'change.of.agent.representative.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0129',
            },
            {
                title: 'request.republication',
                category: 'other',
                description: 'request.republication.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0163',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0165',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0130',
            },
        ],
        recordals: [
            {
                title: 'assignment',
                category: 'other',
                description: 'assignment.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0182',
            },
            {
                title: 'other.recordals',
                category: 'other',
                description: 'other.recordals.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0179',
            },
            {
                title: 'license',
                category: 'other',
                description: 'license.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0177',
            },
            {
                title: 'request.compulsory.license',
                category: 'other',
                description: 'request.compulsory.license.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0176',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0165',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0130',
            },
        ],
        observations: [
            {
                title: 'observations',
                category: 'other',
                description: 'observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0151',
            },
            {
                title: 'reply.to.observations',
                category: 'other',
                description: 'reply.to.observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0150',
            },
        ],
        extinctionRights: [
            {
                title: 'renunciation',
                category: 'other',
                description: 'renunciation.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0140',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0165',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0130',
            },
        ],
        modificationDecision: [
            {
                title: 'request.modification.decision',
                category: 'other',
                description: 'request.modification.decision.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0136',
            },
            {
                title: 'reply.notifications.pt',
                category: 'other',
                description: 'reply.to.notifications.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0131',
            },
            {
                title: 'request.republication',
                category: 'other',
                description: 'request.republication.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0163',
            },
            {
                title: 'observations',
                category: 'other',
                description: 'observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0151',
            },
            {
                title: 'reply.observations',
                category: 'other',
                description: 'reply.observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0150',
            },
            {
                title: 'suspension.examination',
                category: 'other',
                description: 'suspension.examination.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0147',
            },
            {
                title: 'extension.time.limits',
                category: 'other',
                description: 'extension.time.limits.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0149',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0165',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0130',
            },
        ],
        opposition: [
            {
                title: 'opposition',
                category: 'other',
                description: 'opposition.description.extra',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0155',
            },
            {
                title: 'reply.opposition',
                category: 'other',
                description: 'reply.opposition.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0154',
            },
            {
                title: 'reply.notifications.pt',
                category: 'other',
                description: 'reply.to.notifications.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0131',
            },
            {
                title: 'request.republication',
                category: 'other',
                description: 'request.republication.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0163',
            },
            {
                title: 'observations',
                category: 'other',
                description: 'observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0151',
            },
            {
                title: 'reply.observations',
                category: 'other',
                description: 'reply.observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0150',
            },
            {
                title: 'suspension.examination',
                category: 'other',
                description: 'suspension.examination.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0147',
            },
            {
                title: 'extension.time.limits',
                category: 'other',
                description: 'extension.time.limits.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0149',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0165',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0130',
            },
        ],
        // replyNotifications: [
        //     {
        //         title: 'reply.notifications.pt',
        //         category: 'other',
        //         description: 'reply.to.notifications.description',
        //         externalPath: true,
        //         requiredProfileDetails: false,
        //         path: 'eservice.path.0131',
        //     },
        //     {
        //         title: 'request.republication',
        //         category: 'other',
        //         description: 'request.republication.description',
        //         externalPath: true,
        //         requiredProfileDetails: false,
        //         path: 'eservice.path.0163',
        //     },
        // ],
        proofOfRights: [
            {
                title: 'request.proof.of.rights',
                category: 'other',
                description: 'request.proof.of.rights.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0171',
            },
            {
                title: 'extract.certificate.patents',
                category: 'other',
                description: 'extract.certificate.patents.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0174',
            },
        ],
        reestablishmentRights: [
            {
                title: 'request.reestablishment.of.rights',
                category: 'other',
                description: 'request.reestablishment.of.rights.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0135',
            },
            {
                title: 'opposition.against.reestablishment.of.rights',
                category: 'other',
                description: 'opposition.against.reestablishment.of.rights.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0159',
            },
            {
                title: 'request.for.amendments',
                category: 'other',
                description: 'request.for.amendments.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0165',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0130',
            },
        ],
        suspensionTimeChanges: [
            {
                title: 'suspension.examination',
                category: 'other',
                description: 'suspension.examination.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0147',
            },
            {
                title: 'extension.time.limits.pt',
                category: 'other',
                description: 'extension.time.limits.pt.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0149',
            },
            {
                title: 'early.publication',
                category: 'other',
                description: 'early.publication.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0160',
            },
            {
                title: 'deferment.publication',
                category: 'other',
                description: 'deferment.publication.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0161',
            },
        ],
        feesRenewal: [
            {
                title: 'renewal.registration',
                category: 'other',
                description: 'patent.esvc.renewal.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0187',
            },
            {
                title: 'revalidation',
                category: 'other',
                description: 'revalidation.description.pt',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0185',
            },
            {
                title: 'opposition.against.revalidation',
                category: 'other',
                description: 'opposition.against.revalidation.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0156',
            },
            {
                title: 'free.supplement',
                category: 'other',
                description: 'free.supplement.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0110',
            },
            {
                title: 'refund.fees',
                category: 'other',
                description: 'refund.fees.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0105',
            },
            {
                title: 'request.for.correction',
                category: 'other',
                description: 'request.for.correction.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0130',
            },
        ],
        provisionalPatent: [
            {
                title: 'provisional.patent.application',
                category: 'other',
                description: 'provisional.patent.application.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0198',
            },
            {
                title: 'search.report.provisional.patent',
                category: 'other',
                description: 'search.report.provisional.patent.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0120',
            },
            {
                title: 'provisional.patent.conversion',
                category: 'other',
                description: 'provisional.patent.conversion.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0121',
            },
        ],
        supplementaryProtection: [
            {
                title: 'supplementary.protection.certificate',
                category: 'other',
                description: 'supplementary.protection.certificate.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.4199',
            },
            {
                title: 'request.extension.spc',
                category: 'other',
                description: 'request.extension.spc.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0192',
            },
            {
                title: 'request.correct.duration.spc',
                category: 'other',
                description: 'request.correct.duration.spc.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0145',
            },
            {
                title: 'request.correct.duration.spc',
                category: 'other',
                description: 'request.correct.duration.spc.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0145',
            },
            {
                title: 'spc.observations',
                category: 'other',
                description: 'spc.observations.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0151',
            },
        ],
        europeanPatent: [
            {
                title: 'request.provisional.protection',
                category: 'other',
                description: 'request.provisional.protection.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.2195',
            },
            {
                title: 'european.patent',
                category: 'other',
                description: 'european.patent.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'https://epo.servicosonline.inpi.justica.gov.pt/',
                //alt 20260401_JA
                //path: 'eservice.path.2197',
            },
            {
                title: 'translation.european.specification',
                category: 'other',
                description: 'translation.european.specification.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0191',
            },
        ],
        internationalPatent: [
            {
                title: 'request.provisional.protection',
                category: 'other',
                description: 'request.provisional.protection.international.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.3195',
            },
            {
                title: 'request.entry.pct.national',
                category: 'other',
                description: 'request.entry.pct.national.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0294',
            },
            {
                title: 'request.provisional.protection.utility',
                category: 'other',
                description: 'request.provisional.protection.utility.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.3295',
            },
            {
                title: 'request.entry.pct.national.patent',
                category: 'other',
                description: 'request.entry.pct.national.patent.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0194',
            },
        ],
        nationalUtility: [
            {
                title: 'national.utility.model',
                category: 'other',
                description: 'national.utility.model.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0299',
            },
            {
                title: 'request.examination',
                category: 'other',
                description: 'request.examination.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0162',
            },
        ],
        certificate: [
            {
                title: 'certificate.of.grant.electronic',
                category: 'other',
                description: 'certificate.of.grant.electronic.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0111',
            },
            {
                title: 'certificate.of.grant.paper',
                category: 'other',
                description: 'certificate.of.grant.paper.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0167',
            },
            {
                title: 'provisional.certificate.of.grant',
                category: 'other',
                description: 'provisional.certificate.of.grant.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0269',
            },
            {
                title: 'certificate.of.grant.copies',
                category: 'other',
                description: 'certificate.of.grant.copies.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0166',
            },
            {
                title: 'certificate.of.registration',
                category: 'other',
                description: 'certificate.of.registration.description',
                externalPath: true,
                requiredProfileDetails: false,
                path: 'eservice.path.0171',
            },
        ],
    },
};
